module.exports = __webpack_public_path__ + "img/medicine.3ef256c5.svg";